import { getLookupQuery } from 'src/app/helpers/url.helper';
import { apiSlice } from 'src/app/redux/api/apiSlice';
import {
  PersonRecognizedLookupDataType,
  PersonRecognizedLookupResultType,
} from 'src/app/redux/interests/persons/person-slice.type';
import { finalUrlsConfig } from 'src/configs/url.config';

export const personRecognizedSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPersonsRecognized: builder.query<PersonRecognizedLookupResultType, PersonRecognizedLookupDataType | void>({
      query: (params: PersonRecognizedLookupDataType) => ({
        url: finalUrlsConfig().interest.recognized.person,
        params: getLookupQuery(params),
      }),
    }),
  }),
});

export const { useGetPersonsRecognizedQuery } = personRecognizedSlice;
